import { get } from 'lodash'
import * as React from 'react'

import { Experiment as ExperimentType } from '../../types'
import ExperimentActivator from '../ExperimentActivator'

interface WithExperimentOptions {
  objectiveCompletePropName?: string
  selectedVariantPropName?: string
}

// withExperiment is a HOC that provides the following props:
// selectedVariantId - id of the selected variant of the given experiment
// objectiveComplete - callback that triggers the google optimize objective event
const withExperiment = (experiment: ExperimentType, options?: WithExperimentOptions) => (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  WrappedComponent: React.ComponentClass<any> | React.SFC<any>,
) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  class WithExperiment extends React.Component<any> {
    render() {
      return (
        <ExperimentActivator experiment={experiment}>
          {(_, selectedVariantId, objectiveComplete) => {
            const props = { ...this.props }

            const selectedVariantPropName = get(options, 'selectedVariantPropName', 'selectedVariantId')
            const objectiveCompletePropName = get(options, 'objectiveCompletePropName', 'objectiveComplete')

            props[selectedVariantPropName] = selectedVariantId
            props[objectiveCompletePropName] = objectiveComplete

            return <WrappedComponent experiment={experiment} {...props} key={selectedVariantId} />
          }}
        </ExperimentActivator>
      )
    }
  }

export default withExperiment
